module.exports = __webpack_public_path__ + "static/media/externalBarn_9.9cee4b95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/barn/externalBarn_9.png
// module id = 1313
// module chunks = 3